import { lazy } from "react";

/**
Maps the Monarch UI Component customId to the React component path in our repo
**/
const listOfMonarchComponents = {
  cartConfigContactPage: lazy(() => import("./Config | Contact Page")),
  cartOutageContactForm: lazy(() => import("./Outage Contact Form")),
  cartRedesignAllconnectUnserv: lazy(() => import("./Redesign | Allconnect Unserv")),
  cartRedesignAcdInterstitial: lazy(() => import("./Redesign | ACD Interstitial")),
  cartBannerModernEditable: lazy(() => import("./Banner | Modern")),
  cartRedesignAcdInterstitialLoader: lazy(() => import("./Redesign | ACD Interstitial Loader")),
};

export default listOfMonarchComponents;
